export default __webpack_public_path__ + "static/media/favorite1-icon.6a8cccf2.svg";